export default {
  tabs: {0:true,1:false},
  active_options: '',
  selected_tab: false,
  selected_slide: 0,
  selected_slide2: 0,
  selected_variant: -1,
  selected_quantity: 1,
  selected_options: [],
  related: [],
  gallery_active: false,
  notify_email: '',
  message: '',
  error: false,
  letters: [
    'Blank','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'
  ],
  selected_letter: false,
  content_top: -1,
  content_height: -1,
  gallery_top: -1,
  gallery_height: -1,
  sticky_disabled: -1,
  sticky_top: 0
}